<div
  *ngIf="!loading; else loadingTemplate"
  xmlns="http://www.w3.org/1999/html">
  <div class="header-container">
    <div class="header-container__header lx-section-title">
      Release {{ release.name }}
    </div>
    <div
      class="header-container__close"
      (click)="close()">
      <i class="lx-icon lx-close-x"></i>
    </div>
  </div>

  <div class="action">
    <div
      class="action__status-container"
      style="gap: 20px">
      <div class="action__status-container__status lx-body">
        <span
          class="status"
          [ngClass]="getStatusCss(release.status)"></span>
        <span>{{ getStatusName(release.status) }}</span>
      </div>
      <button
        *ngIf="release.hasPendingApproval"
        class="lx-btn-small lx-btn-primary"
        style="min-width: 0px"
        (click)="onReview()">
        Review
      </button>
    </div>
    <div class="action__button-container">
      <button
        class="lx-btn-small lx-btn-negative"
        (click)="onDeleteClick()">
        <span>Delete</span>
      </button>
      <ng-container *ngIf="release.status !== 'Rejected'">
        <button
          class="lx-btn-small lx-btn-negative"
          (click)="
            release.status === 'Disabled'
              ? confirmEnableRelease()
              : confirmDisableRelease()
          ">
          <span>
            {{ release.status === 'Disabled' ? 'Enable' : 'Disable' }}
          </span>
        </button>
        <button
          *ngIf="release.status !== 'Disabled'"
          class="lx-btn-small lx-btn-negative"
          (click)="editRelease()">
          <span>Edit</span>
        </button>
      </ng-container>
    </div>
  </div>

  <div class="divider"></div>

  <div class="body">
    <div class="body__details">
      <div class="body__details__header lx-label">Release Notes</div>
      <div class="body__details__body lx-body">{{ release.description }}</div>
    </div>

    <div class="body__details">
      <div class="body__details__header lx-label">Apps</div>
      <div class="body__details__modules-container">
        <div
          *ngFor="let module of release.modules"
          class="body__details__modules-container__modules lx-body">
          <span
            class="lx-header body__details__modules-container__modules__name">
            {{ module.name }}
          </span>
          <span
            class="lx-body body__details__modules-container__modules__version">
            {{
              module.version +
                '-' +
                (module.hardwarePlatform !== null &&
                module.hardwarePlatform !== undefined
                  ? module.hardwarePlatform
                  : module.platform)
            }}
          </span>
          <span *ngIf="isConfigAvailable(module)">
            <a
              class="body__details__modules-container__modules__config"
              (click)="displayConfig(module)">
              View JSON Config
            </a>
          </span>
        </div>
        <div
          *ngFor="let firmware of release.firmware"
          class="body__details__modules-container__modules lx-body">
          <span
            class="lx-header body__details__modules-container__modules__name">
            {{ firmware.name }}
          </span>
          <span
            class="lx-body body__details__modules-container__modules__version">
            {{ firmware.version + '-' + firmware.platform }}
          </span>
        </div>
      </div>
    </div>
    <div class="divider"></div>

    <div
      *ngFor="let phase of release.phases"
      class="body__phase_container">
      <div class="body__phase_container__header">
        <div class="body__phase_container__header__phase_status">
          <span
            class="body__phase_container__header__phase_status__phase_name lx-title">
            {{ phase.name }}
          </span>
          <span
            class="body__phase_container__header__phase_status__status {{
              phase.status.toLowerCase()
            }} status"></span>
          <span
            class="body__phase_container__header__phase_status__status_text lx-body">
            {{ phase.status }}
          </span>
        </div>
        <div
          *ngIf="phase.status === 'Scheduled'"
          class="body__phase_container__header__date_btn">
          <span
            class="body__phase_container__header__date_btn__date_text lx-body">
            Expected Release Date:
          </span>
          <span class="body__phase_container__header__date_btn__date lx-body">
            {{ phase.expectedReleaseDate | date: 'longDate' }}
          </span>
          <button
            class="body__phase_container__header__date_btn__btn lx-btn-small lx-btn-primary"
            [disabled]="disableDeployPhaseBtn(phase.expectedReleaseDate)"
            (click)="confirmPhaseDeployment(phase.name)">
            <span>Deploy</span>
          </button>
        </div>
      </div>
      <phase-cohorts-details
        [cohorts]="phase.cohorts"
        [devices]=""
        [online]=""></phase-cohorts-details>
    </div>
    <div class="body__details">
      <div class="body__details__totals-container__header lx-title">
        Deployed Phases Total
      </div>
      <div class="body__details__totals-container">
        <div
          *ngFor="let module of release.releaseTotals"
          class="body__details__totals-container__modules lx-body">
          <span
            class="lx-header body__details__totals-container__modules__name">
            {{
              module.moduleId.split('+')[0] +
                '
            ' +
                module.moduleId.split('+')[
                  module.moduleId.split('+').length - 1
                ]
            }}
          </span>
          <span
            class="lx-header body__details__totals-container__modules__ac-label">
            Accepted
          </span>
          <span
            class="lx-body body__details__totals-container__modules__accepted">
            {{ module.acceptedDeviceCount }}
          </span>
          <span
            class="lx-header body__details__totals-container__modules__im-label">
            Impacted
          </span>
          <span
            class="lx-body body__details__totals-container__modules__impacted">
            {{ module.impactedDeviceCount }}
          </span>
        </div>
      </div>
    </div>
    <button
      class="button-container__button lx-btn lx-btn-secondary"
      (click)="close()">
      <span>Close</span>
    </button>
  </div>
</div>

<ng-template #loadingTemplate>
  <div
    class="spinner-border"
    role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</ng-template>
